// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loginErrorPopup_content__3Uk1o {\n  padding-bottom: 20px;\n  box-sizing: border-box; }\n", ""]);
// Exports
exports.locals = {
	"content": "loginErrorPopup_content__3Uk1o"
};
module.exports = exports;
